import React,{useEffect} from 'react'
import Swiper,{Autoplay} from "swiper";

export default function SidebarReferences({data}) {
    useEffect(() => {
        if (data) {
            Swiper.use([Autoplay]);
            new Swiper('.sidebar-refs', {
                autoplay: {
                    delay: 5000,
                },
                loop:true,
                spaceBetween: 0
            });
        }
    }, [data])

  return (
    <div className="refs">
    <h1>{data.category_language.name}</h1>
    <div className="swiper sidebar-refs">
        <div className="swiper-wrapper">
            {data.sub_items.map((item,index) => {
            return item.file && (<div className="swiper-slide" key={index}>
                <div className="ref-item">
                    <img src={item.file} alt={item.category_language.alt?.file} loading='lazy' />
                </div>
            </div>)
            })}
        </div>
        </div>
</div>
  )
}
